import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Leaf, FlaskConical, Award, Heart, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import product1Hero from "../assets/brand/product1.jpg";
import product2Hero from "../assets/brand/product2.jpg";

const VALUES = [
  {
    icon: FlaskConical,
    t: "Haute Formulation",
    d: "Des concentrations actives maximales éprouvées cliniquement pour une efficacité cellulaire visible."
  },
  {
    icon: Leaf,
    t: "Pureté Végétale",
    d: "Ingrédients nobles, zéro parabènes, sans silicones occlusifs et respectueux de la peau."
  },
  {
    icon: ShieldCheck,
    t: "Contrôle Dermatologique",
    d: "Chaque formule est rigoureusement testée pour garantir une tolérance irréprochable sur peaux sensibles."
  },
];

export default function About() {
  return (
    <div id="main" className="pt-28 pb-20 bg-white text-[#111111]">
      {/* Header */}
      <section className="relative overflow-hidden py-16 bg-[#F8F8F6] border-b border-[#EAE8E4]">
        <div className="container-queen">
          <Reveal>
            <p className="label-eyebrow text-[#C5A880] mb-3">La Maison The Queen</p>
            <h1 className="font-display text-4xl sm:text-6xl text-[#111111] leading-tight max-w-3xl">
              L'Excellence de la Haute Dermatologie.
            </h1>
            <p className="text-[#666666] font-body text-base sm:text-lg mt-6 max-w-2xl leading-relaxed">
              Fondée avec l'ambition de redéfinir les standards du soin facial haut de gamme, The Queen conçoit des formules d'exception qui subliment la beauté et l'éclat intemporel de chaque femme.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Philosophy Split */}
      <section className="container-queen py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal className="rounded-3xl overflow-hidden aspect-[4/5] bg-[#F8F8F6] border border-[#EAE8E4] shadow-xl">
            <img src={product1Hero} alt="The Queen Sérum Vitamine C" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal className="space-y-6">
            <p className="label-eyebrow text-[#C5A880]">Notre Vision</p>
            <h2 className="font-display text-3xl sm:text-5xl text-[#111111] leading-tight">
              Quand la Science Rencontre la Grâce.
            </h2>
            <div className="space-y-4 text-sm text-[#555555] font-body leading-relaxed">
              <p>
                Chez The Queen, nous croyons qu'un sérum d'exception ne doit faire aucun compromis entre le raffinement sensoriel et la rigueur scientifique. C'est pourquoi nous avons éliminé le superflu pour nous concentrer sur l'essentiel : des molécules pures, actives et biodisponibles.
              </p>
              <p>
                Notre Sérum Vitamine C à 15% et notre Sérum Acide Hyaluronique multi-moléculaire ont été développés pour répondre aux exigences des peaux les plus délicates, leur apportant hydratation intense, protection antioxydante et régénération profonde.
              </p>
              <p>
                Distribuée à travers les 58 Wilayas d'Algérie avec une livraison soignée et le paiement à la réception, The Queen rend accessible l'expérience du luxe dermatologique le plus pur.
              </p>
            </div>
            <div className="pt-4">
              <Link to="/shop" className="btn-queen-primary">
                Découvrir nos Soins <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#F8F8F6] border-y border-[#EAE8E4]">
        <div className="container-queen">
          <Reveal className="text-center max-w-xl mx-auto mb-16">
            <p className="label-eyebrow text-[#C5A880] mb-2">Nos Engagements</p>
            <h2 className="font-display text-3xl sm:text-4xl text-[#111111]">La Charte The Queen</h2>
          </Reveal>
          <div className="grid sm:grid-cols-3 gap-8">
            {VALUES.map(({ icon: Icon, t, d }, i) => (
              <Reveal key={t} delay={i * 100} className="bg-white p-8 rounded-3xl border border-[#EAE8E4] shadow-sm">
                <div className="w-12 h-12 rounded-full bg-[#111111] text-white grid place-items-center mb-6">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-xl text-[#111111] mb-2">{t}</h3>
                <p className="text-xs text-[#666666] leading-relaxed">{d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
